import {
    SET_SURVEYS,
    SET_CURRENT_SURVEY,
    SET_QUESTION_TYPES,
    SET_SURVEY_CONFIG,
    SET_RESPONSES,
    SET_SUMMARY,
    SET_OVERVIEW,
    SET_BOT_CONFIG
} from "@/views/surveys/store/types/types.js";

const mutations = {
    [SET_SURVEYS]: (state, payload) => state.surveys = payload,
    [SET_CURRENT_SURVEY]: (state, payload) => state.currentSurvey = payload,
    [SET_QUESTION_TYPES]: (state, payload) => state.questionTypes = payload,
    [SET_SURVEY_CONFIG]: (state, payload) => state.surveyConfig = payload,
    [SET_RESPONSES]: (state, payload) => state.responses = payload,
    [SET_SUMMARY]: (state, payload) => state.summary = payload,
    [SET_OVERVIEW]: (state, payload) => state.overview = payload,
    [SET_BOT_CONFIG]: (state, payload) => state.botConfig = payload,
}

export default mutations;
